module.exports = __webpack_public_path__ + "static/media/mailIcon.d49257d2.svg";